/**
 * DEAD SIGNAL — Evidence Registry (derived).
 *
 * EVIDENCE_REGISTRY is now a view over the canonical knowledge plane at
 * src/content/knowledge/data/evidence-bible.json, exposed through the
 * knowledge accessor. The export name and per-record shape match the
 * original hand-written registry (uppercase `type`, `scene`, numeric
 * `chapter`) so existing consumers behave identically; new code should
 * import getEvidence/allEvidence from src/content/knowledge instead.
 */
import { allEvidence } from './knowledge/index.js';

function toLegacyShape(record) {
  const chapter = record.chapterId
    ? Number(String(record.chapterId).replace('ch', '')) || null
    : null;
  return {
    id: record.id,
    title: record.title,
    type: record.type,
    scene: record.sceneId,
    chapter,
    description: record.description,
    corruptible: record.corruptible,
    corruptedDescription: record.corruptedDescription ?? null,
    bioscanTopic: record.bioscanTopic ?? null,
    connections: record.connections,
  };
}

export const EVIDENCE_REGISTRY = Object.fromEntries(
  allEvidence().map((record) => [record.id, toLegacyShape(record)])
);
